import { render, staticRenderFns } from "./Reportes-bancos-transaccionesdobles.vue?vue&type=template&id=605319ca&scoped=true&"
import script from "./Reportes-bancos-transaccionesdobles.vue?vue&type=script&lang=js&"
export * from "./Reportes-bancos-transaccionesdobles.vue?vue&type=script&lang=js&"
import style0 from "./Reportes-bancos-transaccionesdobles.vue?vue&type=style&index=0&id=605319ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605319ca",
  null
  
)

export default component.exports